import { useEffect, useState } from 'react';

const PHONE = '03-3261-9551';

const services = [
  { icon: 'ri-road-map-line', label: '交通誘導警備' },
  { icon: 'ri-building-line', label: 'イベント警備' },
  { icon: 'ri-group-3-line', label: '雑踏警備' },
  { icon: 'ri-alarm-warning-line', label: '緊急・夜間対応' },
];

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_029de2fb390b0fe48b5362348f2d89cd_eb1c539d.jpg"
          alt="道路工事現場での交通誘導警備"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D1A4E]/95 via-[#0D1A4E]/80 to-[#0D1A4E]/15"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D1A4E]/70 via-transparent to-[#0D1A4E]/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6">
        <div
          className={`max-w-2xl transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="flex items-center gap-3 mb-7">
            <div className="w-8 h-0.5 bg-[#38BDF8]"></div>
            <span className="text-[#38BDF8] text-xs font-semibold tracking-[0.2em] uppercase">
              Professional Security Service
            </span>
          </div>

          <h1 className="text-white font-black leading-[1.15] mb-6" style={{ fontSize: 'clamp(2.4rem, 5vw, 3.6rem)', textShadow: '0 2px 16px rgba(0,0,0,0.5)' }}>
            現場の安全を守り抜く、<br />
            <span className="text-[#38BDF8] relative">
              確かな技術
              <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#38BDF8]/50"></span>
            </span>
          </h1>

          <p className="text-white text-base md:text-lg leading-relaxed mb-3" style={{ textShadow: '0 1px 8px rgba(0,0,0,0.6)' }}>
            道路工事・建設現場・各種イベントの交通誘導警備を、<br className="hidden lg:block" />
            有資格のプロフェッショナルが徹底的に管理します。
          </p>
          <p className="text-white/80 text-sm leading-relaxed mb-10" style={{ textShadow: '0 1px 6px rgba(0,0,0,0.6)' }}>
            創業から2年——スピードと品質へのこだわりで依頼件数は急拡大中。<br className="hidden lg:block" />
            一般道・市道・商業施設周辺など、幅広い現場のご依頼をいただいています。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-4">
            <a
              href={`tel:${PHONE}`}
              className="bg-[#38BDF8] hover:bg-[#7dd3fc] text-[#0D1A4E] pl-5 pr-8 py-4 rounded-md font-black whitespace-nowrap transition-colors flex items-center gap-3 cursor-pointer text-base"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#0D1A4E]/15 rounded">
                <i className="ri-phone-fill text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-[#0D1A4E]/60 font-normal leading-none mb-0.5">お電話でのご相談</div>
                <div className="text-xl font-black tracking-wider">{PHONE}</div>
              </div>
            </a>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/50 hover:border-[#38BDF8] hover:text-[#38BDF8] text-white px-8 py-4 rounded-md font-semibold whitespace-nowrap transition-colors cursor-pointer text-sm"
            >
              <i className="ri-mail-line mr-2"></i>
              メール・FAXでのご連絡
            </button>
          </div>
          <p className="text-white/45 text-xs mb-10">
            <i className="ri-time-line mr-1"></i>受付時間：平日 8:00〜18:00
          </p>

          <div className="flex flex-wrap gap-3">
            {services.map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-2 bg-white/10 border border-white/20 text-white/90 text-xs px-3.5 py-2 rounded-full backdrop-blur-sm"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${s.icon} text-[#38BDF8] text-sm`}></i>
                </div>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className={`absolute bottom-0 left-0 right-0 z-10 transition-all duration-1000 delay-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      >
        <div className="max-w-6xl mx-auto px-6 pb-8 flex items-end justify-between">
          <div className="flex items-center gap-6">
            {[
              { num: '2年', label: '設立・急成長中' },
              { num: '200件+', label: '累計対応現場' },
              { num: '24h', label: '緊急対応' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-[#38BDF8] text-2xl font-black">{stat.num}</div>
                <div className="text-white/60 text-xs">{stat.label}</div>
              </div>
            ))}
          </div>
          <button
            onClick={() => scrollTo('strengths')}
            className="text-white/50 hover:text-white/80 transition-colors cursor-pointer animate-bounce"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-down-line text-2xl"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
